import { useSelector } from "react-redux";
import {
  selectDashboardIssuesStatus,
  selectDashboardIssuesStatusLoading,
} from "Redux/Dashboard/slice";
export const useIssuesChartsByStatus = () => {
  const issuesStatus = useSelector(selectDashboardIssuesStatus);
  const loading = useSelector(selectDashboardIssuesStatusLoading);
  const seriesData = [
    issuesStatus.counts.all,
    issuesStatus.counts.open,
    issuesStatus.counts.overdue,
    issuesStatus.counts.resolved,
  ];

  const xAxisData = ["All", "Open", "Overdue", "Resolved"];
  return { seriesData, xAxisData, loading };
};
